import Cookies from 'js-cookie';
import EzUser from 'init/init-user';

export const getCurPopCount = () => parseInt(Cookies.get('pop_count'), 10) || 0;

export const hasHitDownloadLimit = ({ useHighLimit = false } = {}) => {
  if (EzUser.isPro) return false;

  const currCount = getCurPopCount();

  if (useHighLimit) {
    return currCount >= 10;
  }

  return currCount >= 3;
};

// eslint-disable-next-line arrow-body-style
export const showDLLimitModal = ({ useHighLimit = false } = {}) => {
  return hasHitDownloadLimit({ useHighLimit });
};
